import { useEffect } from "react";
import { BUSINESS } from "@/lib/config";

export function useSeo({ title, description, image }) {
  useEffect(() => {
    const full = title ? `${title} — ${BUSINESS.name}` : `${BUSINESS.name} — ${BUSINESS.tagline}`;
    document.title = full;
    const set = (attr, key, val) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", val);
    };
    if (description) set("name", "description", description);
    set("property", "og:title", full);
    if (description) set("property", "og:description", description);
    set("property", "og:type", "website");
    if (image) set("property", "og:image", image);
  }, [title, description, image]);
}
